export default "__VITE_ASSET__BHdutI$I__"